import { Collider } from "./Collider.js";
export async function loadParticlesCollisionsInteraction(engine, refresh = true) {
    await engine.addInteractor("particlesCollisions", (container) => new Collider(container), refresh);
}
